export const panelTitleSx = (theme) => ({
  fontWeight: 700,
  fontSize: 14,
  letterSpacing: "-0.01em",
  color: theme.palette.mode === "dark" ? "#FFFFFF" : "#171717",
  mb: 1,
});

export const panelLabelSx = (theme) => ({
  margin: 0,
  fontWeight: 600,
  fontSize: 12,
  lineHeight: 1.35,
  color: theme.palette.mode === "dark" ? "#D0D0D0" : "#58595B",
});

export const fieldSx = (theme) => {
  const isDark = theme.palette.mode === "dark";
  const primary = theme.palette.primary.main;
  return {
    "& .MuiOutlinedInput-root": {
      borderRadius: "10px",
      minHeight: 36,
      backgroundColor: isDark ? "#161616" : "#F7F7F8",
      transition: "background-color 160ms ease, box-shadow 160ms ease",
      "& fieldset": {
        borderColor: isDark ? "rgba(255,255,255,0.1)" : "rgba(88,89,91,0.14)",
      },
      "&:hover fieldset": {
        borderColor: isDark ? "rgba(255,255,255,0.2)" : `${primary}59`,
      },
      "&.Mui-focused": {
        backgroundColor: isDark ? "#1E1E1E" : "#FFFFFF",
        boxShadow: isDark
          ? `0 0 0 3px ${primary}59`
          : `0 0 0 3px ${primary}1F`,
        "& fieldset": { borderColor: primary },
      },
    },
    "& .MuiInputBase-input": {
      fontSize: 13,
      fontWeight: 500,
      paddingTop: "8px",
      paddingBottom: "8px",
    },
  };
};

export const optionRowSx = (theme, { selected = false, highlighted = false } = {}) => {
  const isDark = theme.palette.mode === "dark";
  let background = "transparent";
  if (selected) background = isDark ? "rgba(255,255,255,0.08)" : "rgba(23,15,74,0.05)";
  else if (highlighted) background = isDark ? "rgba(255,255,255,0.06)" : "rgba(23,15,74,0.04)";

  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: 6,
    width: "100%",
    minHeight: 34,
    padding: "6px 8px",
    borderRadius: 8,
    border: "none",
    background,
    color: isDark ? "#FFFFFF" : "#171717",
    cursor: "pointer",
    textAlign: "left",
    transition: "background-color 120ms ease",
    "&:hover": {
      background: selected
        ? isDark
          ? "rgba(255,255,255,0.1)"
          : "rgba(23,15,74,0.07)"
        : isDark
          ? "rgba(255,255,255,0.06)"
          : "rgba(23,15,74,0.04)",
    },
  };
};

export const optionListSx = (theme) => ({
  mt: 0.75,
  maxHeight: 240,
  overflowY: "auto",
  display: "flex",
  flexDirection: "column",
  gap: 0,
  pr: 0.25,
  scrollbarWidth: "thin",
  scrollbarColor: theme.palette.mode === "dark"
    ? "rgba(255,255,255,0.25) transparent"
    : "rgba(88,89,91,0.28) transparent",
  "&::-webkit-scrollbar": { width: 5 },
  "&::-webkit-scrollbar-thumb": {
    borderRadius: 999,
    backgroundColor: theme.palette.mode === "dark" ? "rgba(255,255,255,0.25)" : "rgba(88,89,91,0.28)",
  },
});
